const urIN= {
    login: {
      title: 'سائن اِن',
      sign_in_btn: 'سائن اِن'
    },
    bar: {
        logout: 'لاگ آؤٹ',
        languages: 'زبانیں',
        settings: 'سیٹنگز کھولیں'
    },
    language: {
      name: 'اردو (بھارت)',
    },
    attributePage: {
        title: 'خصوصیات کی تبدیلیاں',
        viewChanges: 'تبدیلیاں دیکھیں',
        dateTime: 'تاریخ',
        notificationType: 'نوٹیفکیشن کی قسم',
        notificationValue: 'نوٹیفکیشن کی قدر',
        oldValue: 'پرانی قدر',
        newValue: 'نئی قدر',
        accept: 'قبول کریں',
        reject: 'مسترد کریں',
    },
    Home: 'ہوم',
    load: 'ابتدائی لوڈنگ کی جا رہی ہے…',
    Requested: "درخواست کردہ",
    Viewed: "دیکھا گیا",
    Executing: "تعمیل کی جا رہی ہے",
    Completed: "مکمل",
    Expired: "میعاد ختم ہو گئی",
    Cancelled: "منسوخ",
    Error: "خرابی",
    Rejected: "مسترد کردہ",
    error: 'کچھ غلط ہو گیا؛ براہِ کرم بعد میں دوبارہ کوشش کریں۔',
    displayname: 'ڈسپلے کیا جانے والا نام',
    givenname: 'نام',
    surname: 'خاندانی نام',
    email: 'ای میل',
    mail: 'ای میل',
    name: 'نام',
    firstname: 'نام',
    lastname: 'خاندانی نام',
    footer_copyright: 'جملہ حقوق محفوظ ہیں۔'
  };
  
  export default urIN;
  